document.addEventListener('DOMContentLoaded', function() {
  const swiper = new Swiper('#product-logo-slider.swiper', {

      loop: true,
      speed: 2200,  
      
      autoplay: {
        delay: 1,
        disableOnInteraction: false,
      },
    

    spaceBetween: 12,
     slidesPerView: 2,

     breakpoints: {
        360: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
                550: {
          slidesPerView: 4,
          spaceBetween: 20,
        },
    750: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
                810: {
          slidesPerView: 3,
          spaceBetween: 40,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 50,
        },
        1350: {
          slidesPerView: 5,
          spaceBetween: 40,
        },
      }
    });
    });
    document.addEventListener('DOMContentLoaded', function() {
  const swiper = new Swiper('#homepage-logo-slider.swiper', {

      loop: true,
      speed: 2200,  
      
      autoplay: {
        delay: 1,
        disableOnInteraction: false,
      },
    

    spaceBetween: 12,
     slidesPerView: 2,

     breakpoints: {
        360: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
                550: {
          slidesPerView: 4,
          spaceBetween: 20,
        },
    750: {
          slidesPerView: 4,
          spaceBetween: 20,
        },
                810: {
          slidesPerView: 5,
          spaceBetween: 40,
        },
        1024: {
          slidesPerView: 7,
          spaceBetween: 50,
        },
        1350: {
          slidesPerView: 8,
          spaceBetween: 40,
        },
      }
    });
    });